module.exports = __webpack_public_path__ + "img/prepared.4dc71b39.svg";